class articleSns {
  constructor($t) {
    this.$t = $t;
    this.$lists = this.$t.querySelector('.article-sns-lists');
    this.$links = this.$lists.querySelectorAll(':scope > a');
    this.$modalTriggers = document.querySelectorAll('[aria-controls="sns-modal-copy"]');
    this.$modal = document.querySelector('.article-sns-modal');
    this.$modalCopy = this.$modal.querySelector('.article-sns-modal__copy');
    this.$modalCopyDone = this.$modalCopy.querySelector('.article-sns-modal__copy__done');
    this.$modalClose = this.$modal.querySelector('.article-sns-modal__close');
    this.url = this.$lists.dataset.snsUrl;
    this.title = this.$lists.dataset.snsTitle;

    this.$links.forEach($link => {
      if (!$link.classList.contains('is-button-email') && !$link.classList.contains('is-button-copy')) {
        $link.addEventListener('click', event => {
          event.preventDefault();
          this._window($link);
          return false;
        });
      };
    });

    this.$modalTriggers.forEach($trigger => {
      $trigger.addEventListener('click', event => {
        event.preventDefault();
        this._copyModal($trigger);
        return false;
      });
    });

    this.$modalCopy.addEventListener('click', event => {
      event.preventDefault();
      this._copy();
    });
  };
  _window = $link => {
    const href = $link.getAttribute('href');
    const title = $link.getAttribute('title');
    window.open(href, title, 'width=635, height=550, resizable=yes, scrollbars=yes');
  };
  _copyModal = $trigger => {
    let controls = $trigger.getAttribute('aria-controls');
    let $target = document.querySelector(`#${controls}`);
    let isExpanded = $trigger.getAttribute('aria-expanded');
    let isHidden = true;
    if (isExpanded === 'false') {
      isExpanded = true;
      isHidden = false;
    } else {
      isExpanded = false;
      isHidden = true;
    };
    this.$modalCopyDone.style.display = 'none';
    this.$modalTriggers.forEach($trigger => {
      $trigger.setAttribute('aria-expanded', isExpanded);
    });
    $target.setAttribute('aria-hidden', isHidden);
  };
  _copy = () => {
    navigator.clipboard.writeText(this.url);
    this.$modalCopyDone.style.display = 'block';
    setTimeout(() => {
      this._copyModal(this.$modalClose);
    }, 600);
  };
};
const $articleSns = document.querySelector('.article-sns');
if ($articleSns) new articleSns($articleSns);